<template>
  <div class="box">
    <div class="header"></div>
    <div class="lists">
      <div class="title">Token Tracker (VoidChain)</div>
      <div class="list">
        <div class="heading">
          <div class="left">
            <div class="sort">#</div>
            <div class="token">{{ i18n.Token }}</div>
          </div>
          <div class="li">{{ i18n.price }}</div>
          <div class="li">{{ i18n.change }} (%)</div>
          <div class="li">{{ i18n.Tradingvolume }}</div>
          <div class="li">{{ i18n.marketequity }}</div>
          <div class="li">{{ i18n.Highestprice }}</div>
          <div class="li">{{ i18n.Lowestprice }}</div>
        </div>
        <div class="form" v-for="(item, index) in token" :key="item.symbol">
          <div class="left">
            <div class="sort">{{ index + 1 }}</div>
            <!-- <img src="../../image/homePage/logo.png" alt="" /> -->
            <div class="token">{{ item.name }}</div>
            <div class="desc">({{ item.symbol }})</div>
          </div>
          <div class="li">
            <div class="top">{{ item.current_price }} {{ i18n.dollar }}</div>
          </div>
          <div class="li">
            <img src="../../image/TokenList/xia.png" alt="" v-if="item.price_change_percentage_24h < 0" />
            <img src="../../image/TokenList/shang.png" alt="" v-else />
            <div class="rise_fall" v-if="item.price_change_percentage_24h < 0">{{ item.price_change_percentage_24h }}%</div>
            <div class="rise_fall" style="color: #07ab81" v-else>+{{ item.price_change_percentage_24h }}%</div>
          </div>
          <div class="li">{{ item.total_volume }} {{ i18n.dollar }}</div>
          <div class="li">{{ item.market_cap }} {{ i18n.dollar }}</div>
          <div class="li">{{ item.high_24h }} {{ i18n.dollar }}</div>
          <div class="li">{{ item.low_24h }} {{ i18n.dollar }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TokenList',
  data() {
    return {
      token: [],
      time: null,
    }
  },
  mounted() {
    this.gettoken()
    this.time = setInterval(() => {
      this.gettoken()
    }, 60000)
  },
  beforeRouteLeave(to, from, next) {
    if (this.timer) {
      clearInterval(this.timer) // 清除定时器
      this.timer = null // 清除引用，防止内存泄漏
    }
    next() // 确保调用next()以继续路由跳转
  },
  computed: {
    i18n() {
      return this.$t('tokeList')
    },
  },
  methods: {
    gettoken() {
      this.$axios.post('/index/web/webToken', {})
        .then((res) => {
          this.token = res.data.data
        })
        .catch((error) => {
          // Error is already handled by interceptor
          console.error('Failed to fetch token data:', error)
          // Set default empty array to prevent UI issues
          this.token = []
        })
    },
  },
}
</script>
<style lang="scss" src="./TokenList.scss" scoped></style>
